<template>
  <div>
    <div class="body-2 mb-2">{{ label }}</div>
    <v-row align="center">
      <v-col cols="6" md="3">
        <v-text-field
          v-model="newDay"
          type="number"
          min="1"
          max="31"
          label="Día"
          :error-messages="errorMessage"
          @keyup.enter="add"
        />
      </v-col>
      <v-col cols="6" md="4">
        <!-- Cada dia lleva su hora: el 5 a la mañana y el 20 a la tarde. Sin
             hora, ese dia sale en la corrida diaria. -->
        <v-select
          v-model="newHour"
          :items="hourOptions"
          item-text="text"
          item-value="value"
          label="Hora"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-btn :disabled="!isValidNewDay" @click="add">Agregar</v-btn>
      </v-col>
    </v-row>
    <v-chip
      v-for="entry in sortedValue"
      :key="entry.day"
      class="mr-2 mb-2"
      close
      @click:close="remove(entry.day)"
    >{{ chipLabel(entry) }}</v-chip>
    <div v-if="!value.length" class="body-2 grey--text">
      Sin días cargados.
    </div>
    <div class="body-2 grey--text mt-2">
      Un día 31 sale el último día de los meses que no lo tienen: es el
      criterio que aplica el sistema al calcular la fecha real de envío.
    </div>
  </div>
</template>

<script>
"use strict";

import { HOUR_OPTIONS, hourLabel } from "@/utils/send-hour";

const MIN_DAY = 1;
const MAX_DAY = 31;

// Un dia puede llegar como numero suelto (Envios guardados antes de que cada
// dia llevara su hora) o como { day, hour }. Se normaliza al entrar.
const normalizeEntry = entry =>
  entry && typeof entry === "object" ? entry : { day: entry, hour: null };

// Mismo patron que email-list.component.vue: un campo con boton Agregar, una
// fila de chips cerrables, y $emit("input", ...) con un array nuevo en vez de
// mutar el que llega por prop. El valor es [{ day, hour }].
export default {
  name: "day-list",
  props: {
    value: { type: Array, default: () => [] },
    label: { type: String, default: "Días" }
  },
  data() {
    return { newDay: null, newHour: null, errorMessage: null, hourOptions: HOUR_OPTIONS };
  },
  computed: {
    entries() {
      return this.value.map(normalizeEntry);
    },
    // Se muestran ordenados: un recordatorio los dias 5 y 20 se lee mejor asi
    // que "20, 5", que es el orden en que se pudieron haber agregado.
    sortedValue() {
      return this.entries.slice().sort((a, b) => a.day - b.day);
    },
    parsedNewDay() {
      const day = Number(this.newDay);
      return Number.isInteger(day) ? day : null;
    },
    isValidNewDay() {
      const day = this.parsedNewDay;
      return day !== null && day >= MIN_DAY && day <= MAX_DAY && !this.hasDay(day);
    }
  },
  methods: {
    hasDay(day) {
      return this.entries.some(entry => entry.day === day);
    },
    chipLabel(entry) {
      return entry.hour === null || entry.hour === undefined
        ? `${entry.day}`
        : `${entry.day} — ${hourLabel(entry.hour)}`;
    },
    add() {
      const day = this.parsedNewDay;
      if (day === null || day < MIN_DAY || day > MAX_DAY) {
        this.errorMessage = "Ingresá un día entre 1 y 31";
        return;
      }
      if (this.hasDay(day)) {
        this.errorMessage = "Ese día ya está en la lista";
        return;
      }
      this.errorMessage = null;
      const entry = { day: day, hour: this.newHour === undefined ? null : this.newHour };
      this.$emit("input", this.entries.concat(entry).sort((a, b) => a.day - b.day));
      this.newDay = null;
      this.newHour = null;
    },
    remove(day) {
      this.$emit("input", this.entries.filter(entry => entry.day !== day));
    }
  }
};
</script>
